import { useEffect, useState } from "react";

// Internal Imports
import ContentStepper from "../../common/components/ContentStepper.tsx/ContentStepper";
import ConfirmationModal from "../../common/components/Modal/CorfimationModal";
import ModalContainer from "../../common/components/ModalContainer/ModalContainer";
import { fakeListBase, getCopyOf, getError, openNotification, tryCatch } from "../../common/constants/Utilities";
import { Mode } from "../../common/types/AllTypes";
import { useAuth } from "../../contexts/auth";
import { useForm } from "../../contexts/form";
import { IFormList } from "../../interfaces/IFormList";
import { IListBase, ListDetailType } from "../../interfaces/IListado";
import { IResponse } from "../../interfaces/IResponse";
import { Step } from "../../interfaces/IStep";
import { getFormsByListID } from "../../services/form";
import { InsertListBase, UpdateListBase } from "../../services/list";
import StepOne from "./FormSteps/StepOne";
import StepThree from "./FormSteps/StepThree";
import StepTwo from "./FormSteps/StepTwo";
import { IDepartment } from "../../interfaces/IDepartment";

interface Props {
    mode: Mode;
    setMode: React.Dispatch<React.SetStateAction<Mode>>;
    setAddUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
    listDepartment: IDepartment[];
    loadingDeparment: boolean;
    setDataList: (list: IListBase[]) => void;
    dataList: IListBase[]
}


const AddUpdateListadoClientes = ({ mode, setMode, setAddUpdateModal, setDataList, dataList, listDepartment, loadingDeparment }: Props) => {

    // States
    const { setListBaseForm, statusListBaseForm, listBaseForm, loadingSubmit, setLoadingSubmit } = useForm();
    const [canGoNext, setCanGoNext] = useState<boolean>(false);
    const [canGoBack, setCanGoBack] = useState<boolean>(false);
    const { userInformation } = useAuth();
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [formList, setFormList] = useState<IFormList[]>([]);

    // Const
    let ConstSteps = [
        {
            title: 'Información General',
            content: <StepOne mode={mode} setCanGoNext={setCanGoNext} />,
        },
        {
            title: 'Atributos',
            content: <StepTwo mode={mode} setCanGoNext={setCanGoNext} setCanGoBack={setCanGoBack} />,
        },
        {
            title: 'Detalle',
            content: <StepThree mode={mode} setCanGoNext={setCanGoNext} />,
        },
    ];

    // Handles
    const getFormAffectedByList = () => {
        tryCatch(() => {
            getFormsByListID(listBaseForm?.listadoID!)
                .then((response: IResponse) => {
                    setFormList(response.data)
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })

        })
    }

    const handleSubmit = () => {
        tryCatch(() => {
            setLoadingSubmit(true);

            const listbaseClone = listBaseForm!;
            listbaseClone.UsuarioModificoGUID = userInformation!.usuarioGUID;

            if (mode === 'Add') {
                InsertListBase(listbaseClone!, listbaseClone!.listadoDetalle!)
                    .then((response) => {
                        openNotification('success', `Listado agregado`, response.msg!);
                        setAddUpdateModal(false);

                        // reset Table
                        let result: IListBase = response.data;
                        result.departamentoNombre = listDepartment.find(det => det.departamentoGUID === result.departamentoGUID)!.nombre;
                        
                        let dataListInternal = dataList;
                        dataListInternal.push(result);
                        setDataList([...dataListInternal]);
                        setListBaseForm(undefined);
                        //
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setLoadingSubmit(false));
            } else {

                const listBaseDetalleInsertar = listbaseClone!.listadoDetalle!.filter(detalle => detalle.listadoDetalleTipo === ListDetailType.Insertar);
                const listBaseDetalleActualizar = listbaseClone!.listadoDetalle!.filter(detalle => detalle.listadoDetalleTipo === ListDetailType.Actualizar);
                const listBaseDetalleEliminar = listbaseClone!.listadoDetalle!.filter(detalle => detalle.listadoDetalleTipo === ListDetailType.Eliminar);


                UpdateListBase(listbaseClone!, listBaseDetalleInsertar, listBaseDetalleActualizar, listBaseDetalleEliminar)
                    .then((response) => {
                        openNotification('success', `Listado Modificado`, response.msg!);
                        setListBaseForm(response.data);
                        setAddUpdateModal(false);

                        // reset Table
                        let result: IListBase = response.data;
                        result.departamentoNombre = listDepartment.find(det => det.departamentoGUID === result.departamentoGUID)!.nombre;
                        let dataListInternal = dataList;

                        let index = dataList.findIndex(x => x.listadoID === result.listadoID);
                        dataListInternal[index] = result;
                        setDataList([...dataListInternal]);
                        //

                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setLoadingSubmit(false));
            }
        });
    }


    // States
    const [steps, setSteps] = useState<Step[]>(ConstSteps);

    // Effects
    useEffect(() => {
        if (mode === 'Add') {
            setListBaseForm(getCopyOf(fakeListBase));
        }
    }, [mode]);

    useEffect(() => {
        if (modalVisible === true) {
            getFormAffectedByList();
        }
    }, [modalVisible])

    return (
        <ModalContainer style={{ height: '87vh' }}>
            <ContentStepper mode={mode} canSubmit={statusListBaseForm} loadingSubmit={loadingSubmit} steps={steps} canGoBack={canGoBack} canGoNext={canGoNext} method={mode === 'Add' ? handleSubmit : () => setModalVisible(true)} />
            <ConfirmationModal
                title={"Modificar Listado"}
                visible={modalVisible}
                setVisible={setModalVisible}
                question="¿Seguro que deseas modificar este Listado?"
                method={handleSubmit}
                loading={loadingSubmit}
            >
                {formList?.length > 0 &&
                    <div className="errorFileWrapper">
                        <div className="errorFileTitle">Formularios que usan este listado y que serán afectados</div>
                        <div className="listClient_scroll">
                            {formList?.map((form) => (
                                <li>{form.formularioNombre}</li>
                            ))}
                        </div>
                    </div>
                }
            </ConfirmationModal>
        </ModalContainer>
    );
}

export default AddUpdateListadoClientes;